export default __webpack_public_path__ + "e8f6dc68ccf12489584e257c8eb68149.svg";